export default class Watermark {
	constructor(enabled = false, text = 'Not for training', fontSize = 20, opacity = 10, rotation = -20) {
		this.enabled = enabled;
		this.text = text;
		this.styles = {
			fontSize,
			opacity,
			rotation
		}
	}
}